import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'antd';

type ThumbnailTooltipProps = {
  content?: string;
  title?: string;
  width?: number;
};

/**
 * Renders a fixed-width label and value inside a strip thumbnail, adding a hover tooltip only when the text overflows. Measures the rendered content against the width prop in an effect and enables the tooltip once the measured width reaches that limit.
 *
 * @param props - The tooltip title, the content to display and the width it must fit into.
 * @returns The fixed-width title and content row, tooltipped when the content is clipped.
 */
const ThumbnailTooltip = ({ content = '', title = '', width = 0 }: ThumbnailTooltipProps) => {
  const tooltipRef = useRef(null);
  const [isShowTooltip, setShowToolTip] = useState(false);
  useEffect(() => {
    if (tooltipRef.current) {
      setShowToolTip(tooltipRef.current.clientWidth >= width - 1);
    }
  }, [content, width]);
  return (
    <div style={{ width }}>
      <div ref={tooltipRef} className="thumbnail-tooltip-wrapper">
        <div className="thumbnail-tooltip-title">{title}</div>
        <Tooltip
          overlayClassName="thumbnail-tooltip"
          placement="bottomLeft"
          title={isShowTooltip ? content : ''}
        >
          <div className="thumbnail-tooltip-content">{`${content || ''}`}</div>
        </Tooltip>
      </div>
    </div>
  );
};

export default ThumbnailTooltip;
